"use client";

import { WebsiteCtaLink } from "@/app/(website)/_components/website-cta-link";

export function ArticleCTA() {
  return (
    <WebsiteCtaLink href="/login">Start Now</WebsiteCtaLink>
  );
}
